import instance from '@/utils/axios';

/**
 * 本底调查结果
 * @param {{sn:Array<string>,beginTime:number,endTime:number}} data
 * @returns {{code:string,message:string,data:object}}
 */
export function getBgInvestigation(data) {
  return instance.post('/stat/bgInvestigation', data);
}

/**
 * 本底调查导出
 * @param {{sn:Array<string>,beginTime:number,endTime:number,pics:{smoke:string,bio:string}} data
 * @returns {any}
 */
export function exportBgInvestigation(data) {
  return instance.post('/stat/exportBgInvestigation', data);
}

/**
 * 监测分析结果
 * @param {{sn:Array<string>,beginTime:number,endTime:number}} data
 * @returns {{code:string,message:string,data:object}}
 */
export function getMonitorAnalysis(data) {
  return instance.post('/stat/monitorAnalysis', data);
}

/**
 * 监测分析导出
 * @param {{sn:Array<string>,beginTime:number,endTime:number,pics:{smoke:string,bio:string}} data
 * @returns {any}
 */
export function exportMonitorAnalysis(data) {
  return instance.post('/stat/exportMonitorAnalysis', data);
}

/**
 * 扩散分析  列表
 * @param {{ taskId: String, alarmDateBegin: Number, alarmDateEnd: Number, limit: Number, offset: Number}} data
 * @returns {{[index: String]: any}}
 */
export function getTaskAlarmList(data) {
  return instance.post('/taskAlarm/list', data);
}

/**
 * 扩散分析  任务名称列表
 * @returns {{[index: String]: any}}
 */
export function getTaskNameList() {
  return instance.get('/taskAlarm/taskNameList');
}

/**
 * 获取扩散模型详情
 * @param {String} taskId
 */
export function getTaskSmokePuffDetail(taskId) {
  return instance.get('/taskAlarm/taskSmokePuffDetail', { params: { taskId } });
}

/**
 * 查询 安全监测分析报告
 * @returns
 */
export function queryBriefReport(data) {
  return instance.post('/stat/queryBriefReport', data);
}

/**
 * 导出数据 列表查询
 * @param {*} api 接口地址
 * @param {*} data 传参
 * @returns
 */
export function searchResultServer(api, data) {
  return instance.post(api, data);
}
